import React, { Component } from 'react';
//import { withRouter } from 'react-router';
import { Input, Button, Modal, Row, Col } from 'react-materialize';

import OptionsSelector from '../options-selector/OptionsSelector'
import CommonConstants from '../../constants/CommonConstants';
import EventUtils from '../../utils/EventUtils';
import ObjectUtils from '../../utils/ObjectUtils';

import './ReportOptionsModal.css';

class ReportOptionsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedProperties: [],
      imageSize: CommonConstants.FILE_VIEWS_ORIGINAL
    }

    this.PROPERTIES_TO_SHOW = this._getProperties(this.props.selectedAssetType);  // Before Sorting
    this.PROPERTIES_TO_SHOW = ObjectUtils.objectSortingByValue(this.PROPERTIES_TO_SHOW); // After Sorting

    this._handleImageSizeChanged = this._handleImageSizeChanged.bind(this);
    this._handleSelectedPropertiesChanged = this._handleSelectedPropertiesChanged.bind(this);
    this._handleRunReportClick = this._handleRunReportClick.bind(this);
  }

  _getProperties(assetType){
    let _metadata;
    switch(assetType){
      case CommonConstants.ARCHIVE_ASSETS_FILE_TYPE:
          _metadata = CommonConstants.ARCHIVE_PROPERTIES_TO_SHOW;
        break;
      case CommonConstants.ACTIVE_ASSETS_FILE_TYPE:
        _metadata = CommonConstants.ACTIVE_PROPERTIES_TO_SHOW;
        break;
      case CommonConstants.MIXED_ASSETS_FILE_TYPE:
        _metadata = CommonConstants.MIXED_PROPERTIES_TO_SHOW;
        break;
      default:
        break;
    }

    return _metadata;
  }

  _handleImageSizeChanged(event) {
    this.setState({ imageSize: event.target.selectedOptions[0].value });
  }

  _handleSelectedPropertiesChanged(event) {
    this.setState({ selectedProperties: event.detail.selected });
  }

  _handleRunReportClick(event) {
    const { imageSize, selectedProperties } = this.state;

    let properties = {};
    for (let property of selectedProperties) {
      properties[property] = this.PROPERTIES_TO_SHOW[property];
    }

    EventUtils.raiseEvent('changed', { imageSize: imageSize, properties: properties }, this.props);
  }

  render() {
    const { imageSize, selectedProperties } = this.state;

    let modalActions = (
      <div className="modal-footer-actions">
        <Button flat modal="close" waves="light">Cancel</Button>
        <Button className="btn-primary" modal="close" waves="light" onClick={ this._handleRunReportClick }>Run Report</Button>
      </div>
    );

    return (
      <Modal id="report-form-modal" header="Report Options" fixedFooter actions={ modalActions }>
        <Row>
            <Col>
              <Input s={12} type="select" label="Image Size" defaultValue={ imageSize } onChange={ this._handleImageSizeChanged }>
                {
                  CommonConstants.FILE_VIEWS.map((view, id) => <option key={id} value={ view.value }>{ view.text }</option>)
                }
              </Input>
            </Col>
        </Row>
        <OptionsSelector optionsLabel="Available Properties" selectionLabel="Selected Properties" selected={ selectedProperties } options={ this.PROPERTIES_TO_SHOW } onChanged={ this._handleSelectedPropertiesChanged }/>
      </Modal>
    );
  }
}

export default ReportOptionsModal;
